export default class path {
  static BASE_URL = "https://tribute2moms.herokuapp.com/api/v1/tribute"
  static IMAGE_UPLOAD_TO_CONTENTFUL = "/tribute-images-upload-to-contentful"
  static IMAGE_UPLOAD_TO_CLOUDINARY = "/image-upload-cloudinary"
  static TRIBUTE_FORM_SUBMISSION = "/tribute-submission"
  static DELETE_IMAGE_FROM_CLOUDINARY = "/delete-image-from-cloudinary"
  static GET_ALL_MOMS = "/all-moms"
}
